export default "__VITE_ASSET__DgTLgnJr__"